import React, { useState } from 'react'
import { connect } from 'react-redux'
import { numberClearCommas } from 'servos/formValidations'

import {
  getLoanApplication,
  getLoanApplicationId,
  getErrorMessage, getExpensesDisabled, isSecondaryUser,
} from '../../../reducers'

import { scrollToTop } from 'servos/formHelpers'
import { isNumericOnly } from 'servos/formValidations'
import {
  updateExpenseStart
} from '../../../actions'

import TotalExpenses from './TotalExpenses'
import CurrentHome from './CurrentHome'
import MaritalStatus from './MaritalStatus'
import Dependants from './Dependants'
import ExpenseCard from './common/ExpenseCard'
import ActionButtons from '../../commons/ActionButtons'
import GenericIcon from '../../../../../components/GenericIcon'
import {availableExpenses } from './available-expenses'
import ExpensesReviewAlert from './common/ExpensesReviewAlert'

class Expenses extends React.Component {
  state = {
    errors: {},
    maritalStatus: '',
    numberOfDependents: 0,
    residentialStatus: '',
    sellCurrentHome: '',
    currentHomeWorth: '',
    currentHomeRentWorth: '',
    currentHomeRentFrequency: '',
    currentHomeFullAddress: '',
    totalExpenses: 0,
    expensesPropNames: [],
    invalidExpenses: [],
    expensesReady: false,
    continueButtonEnabled: true,
  }

  componentDidMount() {
    window.scrollTo({top: 0})
    const { expenseReference } = this.props

    const expensesPropNames = []
    Object.values(availableExpenses).forEach(typeProps => expensesPropNames.push(...Object.keys(typeProps)))

    if (expenseReference.id !== null) {
      this.setState({
        expensesPropNames,
        residentialStatus: expenseReference.residentialStatus,
        sellCurrentHome: expenseReference.sellCurrentHome,
        currentHomeWorth: expenseReference.currentHomeWorth,
        currentHomeRentWorth: expenseReference.currentHomeRentWorth,
        currentHomeRentFrequency: expenseReference.currentHomeRentFrequency ? expenseReference.currentHomeRentFrequency : 'monthly',
        maritalStatus: expenseReference.maritalStatus,
        numberOfDependents: expenseReference.dependants ? expenseReference.dependants : 0,
        currentHomeFullAddress: expenseReference.currentHomeFullAddress,
        expensesReady: true,
        ...expensesPropNames.reduce((acc, propName) => {
          acc[propName] = expenseReference[propName] || 0
          return acc
        }, {})
      })
    } else {
      this.setState({
        expensesPropNames,
        expensesReady: true,
      })
    }
  }

  validateCurrentHomeAmount = (errors) => {
    const { currentHomeWorth, currentHomeRentWorth } = this.state

    if (currentHomeWorth && (!isNumericOnly(currentHomeWorth))) {
      errors['currentHomeWorth'] = I18n.t('loan_application_user.expenses.errors.not_number')
    }

    if (currentHomeRentWorth && (!isNumericOnly(currentHomeRentWorth))) {
      errors['currentHomeRentWorth'] = I18n.t('loan_application_user.expenses.errors.not_number')
    }
  }

  validateCurrentHomeFullAddress = (errors) => {
    const { residentialStatus, sellCurrentHome, currentHomeFullAddress } = this.state

    if (residentialStatus ===  'own' && sellCurrentHome &&!currentHomeFullAddress) {
      errors['currentHomeFullAddress'] = I18n.t('loan_application_user.expenses.errors.full_address_empty')
    }
  }

  handleExpenses = (propName, value) => {
    const expense = value.replace(/,/g, '')
    this.setState((prevState) => {
      const errors = { ...prevState.errors }
      delete errors[propName]
      return { [propName]: expense, errors }
    })
  }

  handleInvalidExpense = ({ text, invalid }) => {
    let { invalidExpenses } = this.state

    if (invalid) {
      invalidExpenses = [ ...invalidExpenses, text ]
    } else if (invalidExpenses.length) {
      invalidExpenses = invalidExpenses.filter(t => t !== text)
    }

    this.setState({ invalidExpenses })
  }

  validateExpenses = (errors) => {
    for (const propName of this.state.expensesPropNames) {
      const value = this.state[propName]
      if (value !== '' && value !== null && value !== undefined && !isNumericOnly(value)) {
        errors[propName] = I18n.t('loan_application_user.expenses.errors.not_number')
      }
    }
  }

  isValid = () => {
    const {
      needsCurrentHome,
    } = this.props

    let errors = {}

    if (needsCurrentHome) {
      this.validateCurrentHomeAmount(errors)
      this.validateCurrentHomeFullAddress(errors)
    }

    this.validateExpenses(errors)

    this.setState({ errors })
    return Object.keys(errors).length === 0
  }

  onContinueClick = () => {
    if (this.isValid()) {
      if (this.props.flowState !== 'expenses') {
        this.setState({ continueButtonEnabled: false })
      }
      const {
        isSecondaryUser
      } = this.props

      const {
        maritalStatus
      } = this.state

      this.props.updateExpenseStart(!this.props.expensesDisabled ? {
        // Don't change loan application if this is the secondary user
        loan_application: !isSecondaryUser ? {
          primary_enters_data: this.secondaryMatters() ? this.props.primaryEntersData : false,
          secondary_is_defacto: maritalStatus === 'defacto',
          secondary_is_spouse: maritalStatus === 'married',
        } : {primary_enters_data: this.props.primaryEntersData},
        expense: {
          residential_status: this.state.residentialStatus,
          sell_current_home: this.state.sellCurrentHome,
          current_home_worth: this.state.currentHomeWorth,
          current_home_rent_worth: this.state.currentHomeRentWorth,
          current_home_rent_frequency: this.state.currentHomeRentFrequency,
          current_home_full_address: this.state.currentHomeFullAddress,
          marital_status: this.state.maritalStatus,
          dependants: this.state.numberOfDependents,
          ...this.expensesServerValues('housing_expenses'),
          ...this.expensesServerValues('personal_expenses'),
          ...this.expensesServerValues('insurance_expenses'),
        }
      } : {loan_application: {primary_enters_data: true}})
    } else {
      scrollToTop()
    }
  }

  expensesServerValues(expenseType) {
    const values = {}

    const propsForType = availableExpenses[expenseType]
    for (const propName in propsForType) {
      const serverPropName = propsForType[propName].server
      const value = this.state[propName]
      values[serverPropName] = isNaN(parseInt(value)) ? 0 : parseInt(value)
    }

    return values
  }

  secondaryMatters() {
    const {
      hasSecondaryApplicant,
      isSecondaryUser
    } = this.props

    const {
      maritalStatus
    } = this.state

    return hasSecondaryApplicant && !isSecondaryUser && ['defacto', 'married'].includes(maritalStatus)
  }

  /* Use only if there's a secondary applicant */
  isSecondaryDataValid() {
    const { primaryEntersData } = this.props

    const {
      maritalStatus
    } = this.state

    if (this.secondaryMatters()) {
      // Valid if there is no second applicant or values are present
      const defactoValid = maritalStatus === 'defacto'
      const marriedValid = maritalStatus === 'married'
      return defactoValid || marriedValid
    }

    return true
  }

  // ONLY EVALUATE if loan application needs current home
  isCurrentHomeValid() {
    const { needsCurrentHome } = this.props

    if (needsCurrentHome) {
      const {
        residentialStatus,
        sellCurrentHome,
        currentHomeWorth,
        currentHomeRentWorth,
        currentHomeFullAddress,
      } = this.state

      if (residentialStatus == 'own') {
        if (sellCurrentHome && currentHomeWorth && currentHomeFullAddress) {
          return true
        } else if (!sellCurrentHome && currentHomeWorth && currentHomeRentWorth) {
          return true
        } else {
          return false
        }
      } else {
        return residentialStatus
      }
    } else {
      return true
    }
  }

  areExpensesValid() {
    let hasOneLivingExpense = false

    for (const propName in availableExpenses.living_expenses) {
      const value = parseInt(this.state[propName])
      if (value && !isNaN(value)) {
        hasOneLivingExpense = true
        break
      }
    }

    return hasOneLivingExpense
  }

  continueEnabled() {
    const {
      errors,
    } = this.state

    if ((Object.keys(errors).length !== 0)) {
      return false
    }

    return this.isCurrentHomeValid() && this.isSecondaryDataValid()
  }

  handleNumberOfDependents = (event) => {
    let numberOfDependents = this.state.numberOfDependents
    if ((event.target.id == 'plus') && numberOfDependents < 10) {
      numberOfDependents++
    } else if ((event.target.id == 'minus') && numberOfDependents > 0) {
      numberOfDependents--
    }
    this.setState({ numberOfDependents })
  }

  handleResidentialStatus = (value) => {
    this.setState({
      residentialStatus: value,
      sellCurrentHome: '',
      currentHomeWorth: '',
      currentHomeRentWorth: ''
    })
  }

  handleSellCurrentHome = (value) => {
    this.setState({
      sellCurrentHome: value,
      currentHomeRentWorth: ''
    })
  }

  handleCurrentHomeRentFrequency = (value) => {
    this.setState({
      currentHomeRentFrequency: value
    })
  }

  handleCurrentHomeFullAddress = (data) => {
    this.setState({
      currentHomeFullAddress: data.locationFullAddress,
    })
  }

  handleCurrentHomeWorth = (value) => {
    let errors = { ...this.state.errors }
    this.setState({ [event.target.id]: numberClearCommas(value) })
    delete errors[event.target.id]
    this.setState({ errors })
  }

  calculateTotalExpenses = () => {
    let totalExpenses = 0

    this.state.expensesPropNames.forEach((propName) => {
      const value = this.state[propName]
      totalExpenses += isNaN(parseInt(value)) ? 0 : parseInt(value)
    })

    return '$' + String(totalExpenses).replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  renderExpenses = () => {
    const { errors, expensesReady } = this.state

    const {
      expensesDisabled,
    } = this.props

    return expensesReady ? (
      <div>
        <ExpenseCard
          title='Housing monthly expenses'
          errors={ errors }
          id='housing_expenses'
          disabled={ expensesDisabled }
          expenses={ availableExpenses.housing_expenses }
          values={ this.state }
          onChange={ this.handleExpenses }
          onInvalid={ this.handleInvalidExpense }
        />
        <ExpenseCard
          title='Personal monthly expenses'
          errors={ errors }
          id='personal_expenses'
          disabled={ expensesDisabled }
          expenses={ availableExpenses.personal_expenses }
          values={ this.state }
          onChange={ this.handleExpenses }
          onInvalid={ this.handleInvalidExpense }
        />
        <ExpenseCard
          title='Insurance and other monthly expenses'
          errors={ errors }
          id='insurance_expenses'
          disabled={ expensesDisabled }
          expenses={ availableExpenses.insurance_expenses }
          values={ this.state }
          onChange={ this.handleExpenses }
          onInvalid={ this.handleInvalidExpense }
        />
      </div>
    ) : null
  }

  expensesCompletedAlert() {
    const { primaryApplicantName } = this.props

    return (
      <div className='alert alert-success fixed d-flex mb-4' role='alert'>
        <div className='col-auto p-0'>
          <GenericIcon name='checklist' />
        </div>
        <div className='col pr-0'>
          <p>
            <strong>Your combined expenses have already been completed by { primaryApplicantName }</strong><br/>
            { primaryApplicantName } has provided Expenses information on behalf of both of you.
          </p>
          <p className='mb-0'>
            Therefore, you are not required to complete the information below and are only able to view it.
          </p>
        </div>
      </div>
    )
  }

  render() {
    const {
      errors,
      currentHomeRentFrequency,
      residentialStatus,
      sellCurrentHome,
      currentHomeWorth,
      currentHomeRentWorth,
      currentHomeFullAddress,
      maritalStatus,
      numberOfDependents,
      invalidExpenses,
      continueButtonEnabled,
    } = this.state

    const {
      needsCurrentHome,
      expenseReference,
      expensesDisabled,
      isSecondaryUser,
      hasSecondaryApplicant,
      flowState
    } = this.props

    return (
      <div>
        <h3 className='mb-3'>Monthly expenses</h3>

        { expensesDisabled && isSecondaryUser && this.expensesCompletedAlert() }
        {flowState !== 'expenses_2' ? (
          <>
            {
              needsCurrentHome && (
                <CurrentHome
                  disabled={ expensesDisabled }
                  errors={errors}
                  residentialStatus={residentialStatus}
                  sellCurrentHome={sellCurrentHome}
                  currentHomeWorth={currentHomeWorth}
                  currentHomeRentWorth={currentHomeRentWorth}
                  currentHomeRentFrequency={currentHomeRentFrequency}
                  currentHomeFullAddress={currentHomeFullAddress}
                  handleResidentialStatus={this.handleResidentialStatus}
                  handleSellCurrentHome={this.handleSellCurrentHome}
                  handleCurrentHomeWorth={this.handleCurrentHomeWorth}
                  handleCurrentHomeRentFrequency={this.handleCurrentHomeRentFrequency}
                  handleCurrentHomeFullAddress={this.handleCurrentHomeFullAddress}
                />
              )
            }
            <MaritalStatus
              maritalStatus={ maritalStatus }
              onStatusChange={ (value) => { this.setState({ maritalStatus: value}) } }
            />
            <Dependants
              disabled={ expensesDisabled }
              numberOfDependents={numberOfDependents}
              handleNumberOfDependents={this.handleNumberOfDependents}
              savedNumberOfDependents={expenseReference.dependants}
            />
            </>
          )
          :
          this.renderExpenses() 
        }

        {flowState === 'expenses_2' && (
            <TotalExpenses
              calculateTotalExpenses={ this.calculateTotalExpenses() }
            />
          )
        }

        { !isSecondaryUser && <ExpensesReviewAlert invalidExpenses={ invalidExpenses } /> }

        <ActionButtons
          continueEnabled={ this.continueEnabled() && continueButtonEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}


// Set primaryEntersData to be as primary user can only fill out the form
const mapStateToProps = (state) => ({
  expenseReference: state.expense,
  errorMessage: getErrorMessage(state),
  loanApplicationId: getLoanApplicationId(state),
  needsCurrentHome: getLoanApplication(state).needsCurrentHome,
  hasSecondaryApplicant: getLoanApplication(state).hasSecondaryApplicant,
  primaryEntersData: true,
  primaryApplicantName: getLoanApplication(state).primaryApplicantName,
  isSecondaryUser: isSecondaryUser(state),
  expensesDisabled: getExpensesDisabled(state),
})

export default connect(mapStateToProps, {
  updateExpenseStart,
})(Expenses)
